import { PrintJob } from 'services/hardware';

// State Key
export const KEY = 'maintenance';

// Action Types
export const types = {
  SET_KIOSK_HARDWARE_ID_OUT_OF_STOCK: `${KEY}/SET_KIOSK_HARDWARE_ID_OUT_OF_STOCK`,
  SET_LAST_PRINTED_ORDER_DETAILS: `${KEY}/SET_LAST_PRINTED_ORDER_DETAILS`,
  RESET_MAINTENANCE: `${KEY}/RESET_MAINTENANCE`
};

interface LastPrintedOrderDetails {
  dateTime: string;
  printJobs: PrintJob[];
}

export interface MaintenanceState {
  readonly kioskHardwareIdOutOfStock: string | undefined;
  readonly lastPrintedOrderDetails: LastPrintedOrderDetails | null;
}

export interface SetKioskHardwareIdOutOfStock {
  type: typeof types.SET_KIOSK_HARDWARE_ID_OUT_OF_STOCK;
  payload: string | undefined;
}

export interface SetLastPrintedOrderDetails {
  type: typeof types.SET_LAST_PRINTED_ORDER_DETAILS;
  payload: LastPrintedOrderDetails;
}

export interface ResetMaintenance {
  type: typeof types.RESET_MAINTENANCE;
}

export type MaintenanceActionTypes = SetKioskHardwareIdOutOfStock | SetLastPrintedOrderDetails | ResetMaintenance;
